import { useEffect, useState } from "react";
import VisaAllocationlistview from "./Visaallocationlistview";
import { useDispatch, useSelector } from "react-redux";
import { getVisaAllocation } from "../../../../store/Api";
import LoadingWithLable from "../../../../ReusableComponents/Loading/LoadingWithLable";
import { useLocation } from "react-router-dom";
import { setBreadCrumb } from "../../../../store/userSlice";

export default function VisaAllocation() {
  const token = localStorage.getItem("nodeToken");
  const visaAllocationSummaryData = useSelector(
    (state) => state.visaAllocationSummay
  );
  const dispatch = useDispatch();
  const [loading, setLoading] = useState({
    edit: false,
    delete: false,
    listData: false,
    loadingId: "",
  });
  useEffect(() => {
    dispatch(getVisaAllocation(token));
  }, []);

  const location = useLocation();
  useEffect(() => {
    dispatch(
      setBreadCrumb([
        {
          label: "VISA ALLOCATION / REVERSE",
          // link: `/dashboard/project/${projectDetails?.id}`,
        },
      ])
    );
  }, [location]);

  return (
    <>
      {visaAllocationSummaryData?.data ? (
        <VisaAllocationlistview />
      ) : (
        <LoadingWithLable />
      )}
    </>
  );
}
